import Base from 'app/models/base';

export default Base.extend({});



// WEBPACK FOOTER //
// ./app/models/payment_log.js